<template>
  <div
    v-if="field"
    role="button"
    tabindex="0"
    :aria-label="$t('navigation.search')"
    :class="['search-box-field', { '-active': showSearch }]"
    @click="showSearch = true"
    @keydown.enter="showSearch = true"
  >
    <span class="_label">{{ $t('navigation.search') }}</span>
    <span class="_shortcut">{{ shortcut }}</span>
  </div>
  <nav-item
    v-else
    class="search-box"
    :title="$t('navigation.search')"
    icon="search"
    :active="showSearch"
    hover-color="beige"
    @click="showSearch = true"
  />
  <search-dialog v-model:value="showSearch" />
</template>
<script>
import NavItem from '@/components/navigation/NavItem.vue';
import SearchDialog from '@/components/navigation/SearchDialog.vue';
import { EventBus } from '@/lib/event-bus';

export default {
  name: 'SearchBox',
  props: {
    field: {
      type: Boolean,
      default: false,
    },
  },
  components: { SearchDialog, NavItem },
  data() {
    return { showSearch: false };
  },
  computed: {
    shortcut() {
      if (window.navigator.userAgent.includes('Macintosh')) {
        return this.$t('mainNavigation.macSearchKeyBinding');
      }
      return this.$t('mainNavigation.searchKeyBinding');
    },
  },
  methods: {
    handleKeyDown(event) {
      if ((event.ctrlKey || event.metaKey) && event.key === 'k') {
        event.stopPropagation();
        event.preventDefault();
        this.showSearch = true;
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeyDown);
    EventBus.$on('show-search', () => {
      this.showSearch = true;
    });
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
    EventBus.$off('show-search', () => {
      this.showSearch = true;
    });
  },
};

</script>

<style
  scoped
  lang="scss"
  type="text/scss"
>
  .search-box-field {
    display: flex;
    gap: .8rem;
    align-items: center;
    height: 3.2rem;
    padding: 0 .6rem 0 .8rem;
    margin: .8rem .4rem 0;
    color: $font-color-secondary;
    white-space: nowrap;
    cursor: pointer;
    border: 1px solid map_get($grey, 'lighten-3');
    border-radius: .8rem;

    &:hover,
    &.-active {
      background-color: $sidebar-hover-color;
    }

    ._label {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    ._shortcut {
      flex-shrink: 0;
      padding: 0 .4rem;
      margin-left: auto;
      font-size: $font-size-1;
      line-height: 1.8rem;
      background-color: $sidebar-hover-color;
      border-radius: .4rem;
    }
  }
</style>
